/**
 * @file state-badge.component.tsx
 * @description Компонент для отображения статуса внутреннего объекта.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { Badge } from '@components/ui/indicators/badge';
import cn from 'classnames';
import { TBaseObjectDto } from '@src/types';

/**
 * Props для компонента StateBadge отображающего статус объекта
 */
export interface IStateBadgeProps extends React.ComponentProps<typeof Badge> {
    /** Объект состояния содержащий id, name и $type для отображения бейджа */
    state: TBaseObjectDto;
}

export const StateBadge = ({ state, ...props }: IStateBadgeProps) => {
    return (
        <Badge
            label={state?.name}
            status={state?.id || '0'}
            {...props}
            className={cn(
                props.className,
                `w-fit objectForm__header-state font-medium text-[1.2703vmin] leading-[1.2703vmin] normal-case cursor-pointer badge-type-${state?.$type || 'default'} bg-badge-${state?.id || '0'}`
            )}
        />
    );
};
